import * as React from 'react';

import ExclamationMarkBadge16 from './ExclamationMarkBadge16';

export const exclamationMarkBadge16 = () => <ExclamationMarkBadge16 />;

export default {
    title: 'Icon/Line/ExclamationMarkBadge16',
    component: ExclamationMarkBadge16,
    parameters: {
        notes: "`import ExclamationMarkBadge16 from 'box-ui-elements/es/icon/line/ExclamationMarkBadge16';`",
    },
};
